var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntrega(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#CED6D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6083 22.0916L31.373 15.3073",
    stroke: "#124DBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7255 30.719V20.2615C13.7259 19.803 13.847 19.3527 14.0764 18.9558C14.3058 18.5589 14.6356 18.2293 15.0327 18L24.183 12.7713C24.5804 12.5418 25.0313 12.421 25.4902 12.421C25.9491 12.421 26.3999 12.5418 26.7974 12.7713L35.9477 18C36.3447 18.2293 36.6745 18.5589 36.904 18.9558C37.1334 19.3527 37.2544 19.803 37.2549 20.2615V30.719C37.2544 31.1775 37.1334 31.6277 36.904 32.0247C36.6745 32.4216 36.3447 32.7512 35.9477 32.9804L26.7974 38.2092C26.3999 38.4387 25.9491 38.5595 25.4902 38.5595C25.0313 38.5595 24.5804 38.4387 24.183 38.2092L15.0327 32.9804C14.6356 32.7512 14.3058 32.4216 14.0764 32.0247C13.847 31.6277 13.7259 31.1775 13.7255 30.719Z",
    fill: "white",
    stroke: "#CED6D7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9023 18.902L25.4906 25.5033L14.0788 18.902",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9023 18.902L25.4906 25.5033L14.0788 18.902",
    stroke: "#CED6D7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4902 38.6667V25.4902",
    stroke: "#CED6D7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrega);
export default __webpack_public_path__ + "static/media/entrega.9bff42269897c2a3b8422a98f0408f0a.svg";
export { ForwardRef as ReactComponent };